import React from 'react';
import '../App.css';

interface LoginPageProps {
  onLogin: () => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Provider Validator</h1>
        <p className="login-description">
          View and validate provider information for readiness to expose Open Scheduling
        </p>
        <button onClick={onLogin} className="login-button">
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
